import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function AuthCallback() {
  const [params] = useSearchParams();
  const { loginWithToken } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const token = params.get('token');
    const role = params.get('role');
    const error = params.get('sso_error');

    if (error) {
      navigate(`/login?sso_error=${encodeURIComponent(error)}`);
      return;
    }

    if (token) {
      loginWithToken(token).then((user) => {
        if (user?.role === 'admin') navigate('/admin');
        else if (user?.role === 'manager') navigate('/manager');
        else navigate('/portal');
      }).catch(() => {
        navigate('/login?sso_error=Error+al+procesar+token');
      });
    } else {
      navigate('/login');
    }
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-3">
        <div className="h-8 w-8 border-2 border-brand border-t-transparent rounded-full animate-spin" />
        <p className="text-sm text-muted-foreground">Completando inicio de sesión...</p>
      </div>
    </div>
  );
}
